import { lazy } from "react";
import Loadable from "app/components/Loadable";
import OperationalRouteGuard from "app/components/operational-workspace/OperationalRouteGuard";

const PatientForm = Loadable(lazy(() => import("./PatientForm")));
const PatientsList = Loadable(lazy(() => import("./PatientsList")));

const PatientRoutes = [
  {
    path: "/healthcare/patients",
    element: (
      <OperationalRouteGuard moduleId="PATIENT_REGISTRATION">
        <PatientForm />
      </OperationalRouteGuard>
    ),
  },
  {
    path: "/patients",
    element: (
      <OperationalRouteGuard moduleId="PATIENT_REGISTRATION">
        <PatientsList />
      </OperationalRouteGuard>
    ),
  },
];

export default PatientRoutes;
